// extracted by mini-css-extract-plugin
export default {"container":"style_container__Baccu","desc":"style_desc__i3MD4","buttonWrapper":"style_buttonWrapper__ftuWs","mobile":"style_mobile__QUhyr","desktop":"style_desktop__2aKOx"};